const storyModes = {
  VIEW: 1,
  CREATION: 2,
  EDITION: 3,
};

const viewModes = Object.freeze({
  CARD: 'CARD',
  TABLE: 'TABLE',
  CONTACT: 'CONTACT',
  MIRROR: 'MIRROR',
  MIRROR_HISTORIC: 'MIRROR_HISTORIC',
});

const contentModes = {
  STORY: 0,
  CONTACT: 1,
};

const sortOrder = {
  DESC: 'desc',
  ASC: 'asc',
};

export { storyModes, viewModes, contentModes, sortOrder };
